import { useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import eventEmitter from "./eventEmitter";
import { AuthContext } from "../store/ContextStore";
import { useChatHistory } from "../store/ChatHistoryContext";
import { LOGIN, SIGNUP, RESETPASSWORD, PLAYERDASHBOARD, GAMEDASHBOARD, REQUEST_TEAM } from "../constants/routes";

const AuthHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {setUser, setIsAuthenticated} = useContext(AuthContext);
  const { clearHistory } = useChatHistory();

  useEffect(() => {
    const handleUnauthorized = () => {
        clearHistory();
        localStorage.clear();
        navigate(LOGIN);
        setUser({});
        setIsAuthenticated(false);  
    };

    // Check if current path is a public route
    const currentPath = location.pathname;
    
    // Public routes that don't require authentication
    const isPublicRoute = [
      LOGIN,
      SIGNUP,
      RESETPASSWORD,
      '/',
      REQUEST_TEAM,
    ].some(route => currentPath === route || currentPath.startsWith(RESETPASSWORD));
    
    // Check for dynamic routes that should be allowed with authentication
    const isDynamicRoute = 
      currentPath.startsWith(PLAYERDASHBOARD) || 
      currentPath.startsWith(GAMEDASHBOARD);
    
    // If user is already authenticated, allow them to access any route
    const sid_user = localStorage.getItem("sid_user");
    const isAuthenticated = !!sid_user;
    
    // Only redirect to login if:
    // 1. Not a public route
    // 2. Not already authenticated
    if (!isPublicRoute && !isAuthenticated) {
      handleUnauthorized();
    }

    const handleUnauthorizedEvent = () => {
      // Ignore 401s while on public routes like /login so form errors can be shown.
      if (isPublicRoute) return;
      handleUnauthorized();
    };

    eventEmitter.on("unauthorized", handleUnauthorizedEvent);

    return () => {
      eventEmitter.off("unauthorized", handleUnauthorizedEvent);
    };
  }, [navigate, location.pathname]);

  return null; // This component only listens for events
};

export default AuthHandler;
